import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Input, Icon } from 'antd';
import PropTypes from 'prop-types';
import TableView from '../../Components/Table';
import search from '../../Images/Icons/search.svg';
import { fetchInferences, runtimeExport } from './RuntimeHistory.saga';
import 'antd/dist/antd.css';
import './RuntimeHistory.css';

const columnNames = {
  image: {
    title: 'IMAGE',
    key: 'imagePath',
    dataIndex: 'imagePath',
    width: '10%',
    order: 0,
  },
  name: {
    title: 'RUNTIME NAME',
    dataIndex: 'runtimeName',
    key: 'runtimeName',
    editable: true,
    width: '15%',
    order: 1,
  },
  modelStatus: {
    title: 'CURRENT STATUS',
    dataIndex: 'runtimeStatus',
    key: 'runtimeStatus',
    width: '18%',
    order: 2,
  },
  createdDate: {
    title: 'CREATED DATE',
    dataIndex: 'runtimeCreatedDate',
    key: 'runtimeCreatedDate',
    width: '15%',
    order: 4,
  },
  actions: {
    title: 'ACTIONS',
    dataIndex: 'actions',
    key: 'actions',
    width: '20%',
    dropDownList: null,
    export: 'Export Result',
    order: 10,
  },
};

const { Search } = Input;

function RuntimeHistory({
  fetchInferencesAction,
  history,
  inferences,
  exportLoader,
  showRedundantViews,
  runtimeExportAction,
  pageOffset,
  match,
}) {
  const [fetchInferenceParams, setFetchInferenceParams] = useState({
    offset: pageOffset || 0,
    size: 7,
    searchValue: '',
    sortBy: '',
    sortDirection: '',
    id: match?.params?.modelId,
  });

  const permissions = { showActions: true, export: true };
  const inferencesList = inferences && inferences.inferenceDetails;
  const totalInferences = inferences && inferences.count;

  useEffect(() => {
    fetchInferencesAction({
      params: fetchInferenceParams,
    });
  }, [fetchInferencesAction, fetchInferenceParams]);

  const modelSearch = (value) => {
    setFetchInferenceParams((prevParams) => ({
      ...prevParams,
      searchValue: value,
      offset: 0,
    }));
  };

  const onPageChange = (offset, sortBy, sortDirection) => {
    setFetchInferenceParams((prevParams) => ({
      ...prevParams,
      offset,
      sortBy,
      sortDirection,
    }));
  };

  const onInferenceClick = (record) => {
    history.push(
      `/model-list/${fetchInferenceParams.id}/inference/${record.runtimeId}`
    );
  };

  const exportRuntime = (id) => {
    runtimeExportAction(id);
  };

  const clientHeight =
    document.getElementById('tableContainer') &&
    document.getElementById('tableContainer').clientHeight;
  return (
    <>
      <div className="modelListContent" id="modelContent">
        <div className="tableWrapper" id="tableContainer">
          <div className="modelListOptionsContainer">
            <Search
              prefix={
                <Icon
                  component={() => (
                    <img
                      src={search}
                      style={{ height: '20px' }}
                      alt="searchIcon"
                    />
                  )}
                />
              }
              placeholder="Search runtime"
              onChange={(e) => modelSearch(e.target.value)}
              className="modelSearchInputBox"
            />
          </div>
          <TableView
            clientHeight={clientHeight - 150}
            columnNames={columnNames}
            totalRecords={totalInferences}
            data={inferencesList}
            title="Inference"
            currentPage={fetchInferenceParams.offset}
            fetchRecords={onPageChange}
            tableType="inference"
            onRecordClick={onInferenceClick}
            permissions={permissions}
            runtimeExport={exportRuntime}
            exportLoader={exportLoader}
            showRedundantViews={showRedundantViews}
            runtime
          />
        </div>
      </div>
    </>
  );
}

RuntimeHistory.defaultProps = {
  fetchInferencesAction: (f) => f,
  history: {
    push: (f) => f,
  },
  inferences: {},
  exportLoader: {},
  showRedundantViews: false,
  runtimeExportAction: (f) => f,
  pageOffset: 0,
  match: {},
};

RuntimeHistory.propTypes = {
  fetchInferencesAction: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  inferences: PropTypes.instanceOf(Object),
  exportLoader: PropTypes.instanceOf(Object),
  showRedundantViews: PropTypes.bool,
  runtimeExportAction: PropTypes.func,
  pageOffset: PropTypes.bool,
  match: PropTypes.shape({
    params: PropTypes.instanceOf(Object),
  }),
};

export default withRouter(
  connect(
    (state) => ({
      inferences:
        state.runtimeHistoryReducer && state.runtimeHistoryReducer.entity,
      exportLoader: state.loginReducer.loginReducer,
      showRedundantViews: state.commonReducer.showRedundantViews,
    }),
    {
      fetchInferencesAction: fetchInferences,
      runtimeExportAction: runtimeExport,
    }
  )(RuntimeHistory)
);
